[
	{
		"content_id": "footer-copy-label",
		"data": "Copyright ©"
	},
	{
		"content_id": "footer-app-store-title",
		"data": "Get the app"
	},
	{
		"content_id": "footer-app-store-link-apple",
		"data": "https://apps.apple.com/us/app/blueprint-portal/id1074008492"
	},
	{
		"content_id": "footer-app-store-alt-apple",
		"data": "Apple play store logo link"
	},
	{
		"content_id": "footer-app-store-link-google",
		"data": "https://play.google.com/store/apps/details?id=com.abcbs.ark_blue_cross&hl=en_US&gl=US"
	},
	{
		"content_id": "footer-app-store-alt-apple",
		"data": "Google play store logo link"
	},
	{
		"content_id": "footer-linking-button",
		"data": "Linking Disclaimer"
	},
	{
		"content_id": "footer-license-text-generic",
		"data": "Arkansas Blue Cross and Blue Shield, BlueAdvantage Administrators of Arkansas, Health Advantage, Octave Blue Cross and Blue Shield, and Skai Blue Cross Blue Shield are independent licensees of the Blue Cross and Blue Shield Association and are licensed to offer health plans in all 75 counties of Arkansas."
	},
	{
		"content_id": "footer-logo-alt-generic",
		"data": "Blueprint Portal"
	},
	{
		"content_id": "footer-license-text-abcbs",
		"data": "Arkansas Blue Cross and Blue Shield is an Independent Licensee of the Blue Cross and Blue Shield Association and is licensed to offer health plans in all 75 counties of Arkansas."
	},
	{
		"content_id": "footer-lob-abbr-abcbs",
		"data": "ABCBS"
	},
	{
		"content_id": "footer-lob-full-abcbs",
		"data": "Arkansas Blue Cross and Blue Shield"
	},
	{
		"content_id": "footer-license-text-ha",
		"data": "Health Advantage is an Independent Licensee of the Blue Cross and Blue Shield Association and is licensed to offer health plans in all 75 counties of Arkansas."
	},
	{
		"content_id": "footer-lob-abbr-ha",
		"data": "HA"
	},
	{
		"content_id": "footer-lob-full-ha",
		"data": "HMO Partners, Inc."
	},
	{
		"content_id": "footer-license-text-ba",
		"data": "BlueAdvantage Administrators of Arkansas is an Independent Licensee of the Blue Cross and Blue Shield Association and is licensed to offer health plans in all 75 counties of Arkansas."
	},
	{
		"content_id": "footer-lob-abbr-ba",
		"data": "BAAA"
	},
	{
		"content_id": "footer-lob-full-ba",
		"data": "BlueAdvantage Administrators of Arkansas"
	},
	{
		"content_id": "footer-license-text-octave",
		"data": "This website is owned and operated by USAble HMO Inc., d/b/a Octave Blue Cross and Blue Shield. Octave Blue Cross is an Independent Licensee of the Blue Cross Blue Shield Association and is licensed to offer health plans in all 75 counties of Arkansas."
	},
	{
		"content_id": "footer-lob-abbr-octave",
		"data": "Octave"
	},
	{
		"content_id": "footer-lob-full-octave",
		"data": "Octave Blue Cross and Blue Shield"
	},
	{
		"content_id": "footer-license-text-skai",
		"data": "This website is owned and operated by USAble Mutual Insurance Company, d/b/a Skai Blue Cross Blue Shield. Skai Blue Cross Blue Shield is an Independent Licensee of the Blue Cross and Blue Shield Association."
	},
	{
		"content_id": "footer-lob-abbr-skai",
		"data": "Skai"
	},
	{
		"content_id": "footer-lob-full-skai",
		"data": "Skai Blue Cross Blue Shield"
	},
	{
		"content_id": "footer-license-text-abm",
		"data": "Arkansas Blue Medicare is an Independent Licensee of the Blue Cross and Blue Shield Association and is licensed to offer health plans in all 75 counties of Arkansas."
	},
	{
		"content_id": "footer-lob-abbr-abm",
		"data": "ABCBS"
	},
	{
		"content_id": "404-title",
		"data": "How did you end up here?"
	},
	{
		"content_id": "404-content",
		"data": "The page you're looking for is nowhere to be found."
	},
	{
		"content_id": "404-button",
		"data": "Back to home"
	},
	{
		"content_id": "footer-lob-full-abm",
		"data": "Arkansas Blue Cross and Blue Shield"
	},
	{
		"content_id": "registration-template-already-open",
		"data": "Already have an account?"
	},
	{
		"content_id": "registration-template-already-link",
		"data": "Sign In"
	},
	{
		"content_id": "registration-verify-alert-authorized-only",
		"data": "<p><strong>ATTENTION:</strong> Registration of member accounts is reserved for MEMBERS or AUTHORIZED REPRESENTATIVES ONLY. If you are not a member or authorized representative, access to this portal is limited by HIPAA 45 CFR 164.514(d). Unauthorized registration is strictly prohibited. Please contact customer service with any questions regarding account access.</p>"
	},
	{
		"content_id": "registration-verify-alert-account-info",
		"data": "Enter information exactly as it appears on your ID Card"
	},
	{
		"content_id": "registration-verify-options-label-mid",
		"data": "Member ID Number"
	},
	{
		"content_id": "registration-verify-options-label-ssn",
		"data": "Member ID Number"
	},
	{
		"content_id": "registration-verify-options-label-mbi",
		"data": "Member ID Number"
	},
	{
		"content_id": "registration-verify-label-mid",
		"data": "Member ID Number"
	},
	{
		"content_id": "registration-verify-label-ssn",
		"data": "Social Security - Last 4 Only"
	},
	{
		"content_id": "registration-verify-label-mbi",
		"data": "MBI Number (Last 4 characters only)"
	},
	{
		"content_id": "registration-verify-label-first-name",
		"data": "First Name"
	},
	{
		"content_id": "registration-verify-label-middle-name",
		"data": "Middle Name"
	},
	{
		"content_id": "registration-verify-label-last-name",
		"data": "Last Name"
	},
	{
		"content_id": "registration-verify-label-dob",
		"data": "Date of Birth"
	},
	{
		"content_id": "registration-verify-label-relationship-member",
		"data": "I am the member"
	},
	{
		"content_id": "registration-verify-label-relationship-guardian",
		"data": "I am the authorized representative of the member"
	},
	{
		"content_id": "registration-verify-label-guardian-legend",
		"data": "Do you have an existing appointment of representation form on file with customer service?"
	},
	{
		"content_id": "registration-verify-label-guardian-first-name",
		"data": "Guardian First Name"
	},
	{
		"content_id": "registration-verify-label-guardian-middle-name",
		"data": "Guardian Middle Name"
	},
	{
		"content_id": "registration-verify-label-guardian-last-name",
		"data": "Guardian Last Name"
	},
	{
		"content_id": "registration-verify-alert-guardian-no",
		"data": "In order to continue, please contact the customer service phone number on the back of your member ID card. You will be able to complete the appropriate authorization forms to access the member's data."
	},
	{
		"content_id": "registration-verify-guardian-info-one",
		"data": "Parent or guardian of a minor"
	},
	{
		"content_id": "registration-verify-guardian-info-two",
		"data": "Active health care power of attorney"
	},
	{
		"content_id": "registration-verify-guardian-info-three",
		"data": "Court ordered guardianship"
	},
	{
		"content_id": "registration-verify-info-page-description-one",
		"data": "Please enter the 6-digit code sent to your email or mobile phone."
	},
	{
		"content_id": "registration-verify-info-page-description-two",
		"data": "Send a 5-digit code to your email or mobile phone."
	},
	{
		"content_id": "registration-verify-info-email-label",
		"data": "Email"
	},
	{
		"content_id": "registration-verify-info-text-label",
		"data": "Text"
	},
	{
		"content_id": "registration-verify-info-verify-button",
		"data": "Select"
	},
	{
		"content_id": "registration-verify-info-rates",
		"data": "Message and data rates may apply."
	},
	{
		"content_id": "registration-verify-info-help-title",
		"data": "Need Help?"
	},
	{
		"content_id": "registration-verify-info-help-content",
		"data": "If you need to change your email address or mobile phone on file in order to verify your Blueprint Portal account, please contact"
	},
	{
		"content_id": "registration-verify-info-help-link",
		"data": "customer service"
	},
	{
		"content_id": "registration-verify-info-input-label",
		"data": "Enter code"
	},
	{
		"content_id": "registration-verify-info-send-again-text",
		"data": "Haven't received a text? Be sure to check your spam folder or"
	},
	{
		"content_id": "registration-verify-info-send-again-email",
		"data": "Haven't received an email? Be sure to check your spam folder or"
	},
	{
		"content_id": "registration-verify-info-send-again-link",
		"data": "send again"
	},
	{
		"content_id": "registration-modal-missing-info-title",
		"data": "Missing Information on File"
	},
	{
		"content_id": "registration-modal-missing-info-content",
		"data": "<p>Blueprint Portal uses the existing contact information we have on file to verify your registration. A valid email or mobile phone number is required to continue. </p><p class=\"mt-3\">We are missing your email and mobile phone number at this time. Please call <a href=\"tel:5013782000\">501-378-2000</a> to update your contact information on file. Customer service representatives are available during normal business hours Monday through Friday.</p>"
	},
	{
		"content_id": "pharmacy-card-description",
		"data": "Visit the Pharmacy Center to research medications, review your drug lists, contact pharmacists, and more."
	},
	{
		"content_id": "pharmacy-card-button-label",
		"data": "Go to Pharmacy Center"
	},
	{
		"content_id": "claims-details-button-print",
		"data": "Print claim"
	},
	{
		"content_id": "claims-details-button-report",
		"data": "Report Fraud and Abuse"
	},
	{
		"content_id": "go-paperless-settings-eobs-description",
		"data": "Receive status updates and notifications about your processed claims through email. By turning off paperless, you’ll receive this information via mail to the address we have on file. You can change this election at any time."
	},
	{
		"content_id": "go-paperless-settings-member-only-description",
		"data": "Stay informed and enjoy exclusive promotions and updates. Message and data rates may apply."
	},
	{
		"content_id": "go-paperless-settings-moen-description",
		"data": "You will be notified when your letter is available online. Members opting in to paperless notifications after Oct. 15 will receive a mailed letter this year and an email next year."
	},
	{
		"content_id": "go-paperless-settings-eobs-success",
		"data": "Paperless EOBs have been updated."
	},
	{
		"content_id": "go-paperless-settings-marketing-success",
		"data": "Member Notifications have been updated."
	},
	{
		"content_id": "go-paperless-settings-celeste-success",
		"data": "Celeste Notifications have been updated."
	},
	{
		"content_id": "go-paperless-settings-annual-benefit-update-letter-success",
		"data": "Paperless Annual Benefit Update Letter has been updated."
	},
	{
		"content_id": "no-primary-care-provider-description",
		"data": "No matter how healthy you are, it's a good idea to choose a primary care physician (PCP) to manage your general health. He or she will be more familiar with your medical history and able to identify issues early on."
	},
	{
		"content_id": "bhealth-form-submit-fail",
		"data": "Your message has not been submitted. Please try again later."
	},
	{
		"content_id": "bhealth-form-submit-success",
		"data": "Your message has been submitted."
	},
	{
		"content_id": "button-back-dashboard",
		"data": "Back to Dashboard"
	},
	{
		"content_id": "eob-error-message",
		"data": "No explanation of benefits to display."
	},
	{
		"content_id": "eob-error-export-single",
		"data": "There was an error while downloading your Explanation of Benefits (EOB) document. Please try again later."
	},
	{
		"content_id": "eob-error-export-all",
		"data": "There was an error while exporting your Explanation of Benefits (EOB) documents. Please try again later."
	},
	{
		"content_id": "eob-family-access-policyholder",
		"data": "If an Explanation of Benefits (EOB) document contains information protected under privacy rules, that information will not be displayed. To see the EOBs of your adult dependents, they must grant permission by activating \"family access\" in the Settings section of their own Blueprint Portal account."
	},
	{
		"content_id": "eob-family-access-solo",
		"data": "If an Explanation of Benefits (EOB) document contains information protected under privacy rules, that information will not be displayed."
	},
	{
		"content_id": "idcard-page-title",
		"data": "Member ID Card"
	},
	{
		"content_id": "idcard-placeholder-warning-title",
		"data": "ID card is still being processed."
	},
	{
		"content_id": "idcard-placeholder-warning-subtitle",
		"data": "Your member ID card is not available yet."
	},
	{
		"content_id": "idcard-placeholder-warning-description",
		"data": "Please check back later. If you have any questions, please contact customer service."
	},
	{
		"content_id": "idcard-placeholder-error-subtitle",
		"data": "Sorry, we're unable to load your card."
	},
	{
		"content_id": "idcard-placeholder-error-description",
		"data": "Try again later."
	},
	{
		"content_id": "idcard-image-alt",
		"data": "Member ID Card for"
	},
	{
		"content_id": "idcard-modal-email-title",
		"data": "Email ID Card"
	},
	{
		"content_id": "idcard-email-success",
		"data": "Your ID card has been successfully emailed."
	},
	{
		"content_id": "idcard-modal-mail-title",
		"data": "Mail ID Card"
	},
	{
		"content_id": "idcard-modal-mail-description",
		"data": "Are you sure you want to mail your ID card?"
	},
	{
		"content_id": "idcard-modal-mail-subtitle",
		"data": "New ID cards will be mailed to the home address for the selected member. To change your address, please call customer service."
	},
	{
		"content_id": "idcard-mail-success",
		"data": "Your ID cards have been ordered and should arrive within 7 business days."
	},
	{
		"content_id": "idcard-generic-error",
		"data": ""
	},
	{
		"content_id": "form-input-email",
		"data": "Email Address"
	},
	{
		"content_id": "site-timeout-message",
		"data": "For your security, we'll automatically sign you out. Choose \"Stay signed in\" to continue or \"Sign out\" if you're done."
	},
	{
		"content_id": "settings-profile-contact-update-fallback",
		"data": "Please contact your employer to update your address information."
	},
	{
		"content_id": "settings-profile-contact-update-arhome",
		"data": "Please call <a href=\"tel:18553721084\">1-855-372-1084</a> or visit <a href=\"https://access.arkansas.gov/Learn/Home\" target=\"_blank\">access.arkansas.gov</a> to update your contact information with DHS."
	},
	{
		"content_id": "settings-profile-contact-update-exchange",
		"data": "Please call <a href=\"tel:18003182596\">1-800-318-2596</a> (TTY: <a href=\"tel:18558894325\">1-855-889-4325</a>) or visit <a href=\"https://www.healthcare.gov/contact-us/\" target=\"_blank\">healthcare.gov/contact-us</a> to update your address information."
	},
	{
		"content_id": "settings-profile-contact-update-medicare",
		"data": "Contact customer service by calling the number on your member ID card to update your address information."
	},
	{
		"content_id": "spending-details-range-label-duration",
		"data": "Current Plan Duration"
	},
	{
		"content_id": "spending-details-range-label-year",
		"data": "Current Plan Year"
	},
	{
		"content_id": "spending-details-modal-deductible",
		"data": "Your deductible is the amount you pay for covered health care services before your benefit plan starts paying its share of covered expenses. After you pay your deductible you only pay the coinsurance for covered services."
	},
	{
		"content_id": "spending-details-modal-out-of-pocket",
		"data": "Your out-of-pocket costs are the amount you have paid for medical services so far, which may include deductibles, coinsurance, or copayments for covered services. It does not include your monthly premium. If you reach the maximum, services are covered at 100%."
	},
	{
		"content_id": "spending-details-breakout-title",
		"data": "Individual Spending"
	},
	{
		"content_id": "spending-details-breakout-subtitle",
		"data": "For an individual - When a person meets his individual deductible, insurance pays for covered services for that person."
	},
	{
		"content_id": "preventive-wellness-page-title",
		"data": "Preventive Wellness Services"
	},
	{
		"content_id": "preventive-wellness-page-subtitle",
		"data": "Under the Affordable Care Act, your health plan covers many preventive services at no cost."
	},
	{
		"content_id": "preventive-wellness-tab-title-adult",
		"data": "Adult Screenings"
	},
	{
		"content_id": "preventive-wellness-tab-title-women",
		"data": "Women's Health Screenings"
	},
	{
		"content_id": "preventive-wellness-tab-title-pregnant",
		"data": "Pregnant Women"
	},
	{
		"content_id": "preventive-wellness-tab-title-children",
		"data": "Children & Teens"
	},
	{
		"content_id": "preventive-wellness-promo-btn",
		"data": "Download Wellness Card"
	},
	{
		"content_id": "preventive-wellness-glossary-btn",
		"data": "Important things to know / Glossary"
	},
	{
		"content_id": "preventive-wellness-card-frequency",
		"data": "How often"
	},
	{
		"content_id": "preventive-wellness-card-when",
		"data": "When"
	},
	{
		"content_id": "preventive-wellness-card-age",
		"data": "Ages"
	},
	{
		"content_id": "preventive-wellness-card-who",
		"data": "Who should get it"
	},
	{
		"content_id": "id-card-arhome-2026-order-notice",
		"data": "Ordering a new ID card by mail is temporarily unavailable due to the open enrollment period. This service will resume 1/6/2027. Please access your ID card using one of the other methods available on this screen."
	},
	{
		"content_id": "authorizations-card-member-id",
		"data": "Member ID:"
	},
	{
		"content_id": "authorizations-card-auth-number",
		"data": "Authorization Number:"
	},
	{
		"content_id": "authorizations-card-start-date",
		"data": "Start Date:"
	},
	{
		"content_id": "authorizations-card-details-button",
		"data": "Details"
	},
	{
		"content_id": "authorizations-details-label-number",
		"data": "Authorization Number:"
	},
	{
		"content_id": "authorizations-details-label-reason",
		"data": "Reason:"
	},
	{
		"content_id": "authorizations-details-label-placeService",
		"data": "Place of Service"
	},
	{
		"content_id": "authorizations-details-label-requestType",
		"data": "Request Type"
	},
	{
		"content_id": "authorizations-details-label-inpatientReason",
		"data": "Inpatient Stay Reason"
	},
	{
		"content_id": "authorizations-details-label-approvedLoc",
		"data": "Approved Level of Care"
	},
	{
		"content_id": "authorizations-details-label-adminDate",
		"data": "Inpatient Admission Date"
	},
	{
		"content_id": "authorizations-details-label-lengthStay",
		"data": "Approved Length of Stay"
	},
	{
		"content_id": "authorizations-details-provider-title",
		"data": "Servicing Provider"
	},
	{
		"content_id": "authorizations-details-provider-name",
		"data": "Name"
	},
	{
		"content_id": "authorizations-details-provider-npi",
		"data": "NPI Number"
	},
	{
		"content_id": "authorizations-details-provider-address",
		"data": "Address"
	},
	{
		"content_id": "authorizations-details-procedure-title",
		"data": "Procedure"
	},
	{
		"content_id": "authorizations-details-procedure-procedureCode",
		"data": "Procedure Code"
	},
	{
		"content_id": "authorizations-details-procedure-description",
		"data": "Description"
	},
	{
		"content_id": "authorizations-details-procedure-status",
		"data": "Status"
	},
	{
		"content_id": "authorizations-details-procedure-statusReason",
		"data": "Status Reason"
	},
	{
		"content_id": "authorizations-details-procedure-startDate",
		"data": "Start Date"
	},
	{
		"content_id": "authorizations-details-procedure-endDate",
		"data": "End Date"
	},
	{
		"content_id": "authorizations-details-procedure-approvedUnit",
		"data": "Approved Units"
	},
	{
		"content_id": "authorizations-details-procedure-approvedUnitLabel",
		"data": "approved units explanation"
	},
	{
		"content_id": "authorizations-details-approvedUnit-modal-title",
		"data": "Approved Units"
	},
	{
		"content_id": "authorizations-details-approvedUnit-modal-description",
		"data": "Could be units, visits, hours, days or quantity. Refer to your authorization letter or talk to your provider for more information."
	},
	{
		"content_id": "authorizations-details-approvedUnit-modal-close",
		"data": "Close"
	},

	{
		"content_id": "authorizations-details-procedure-deniedUnits",
		"data": "Denied Units"
	}
]
